var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "15 0 200 229",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 39,
    fill: "#ea4335",
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 89,
    fill: "#ea4335",
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 139,
    fill: "#ea4335",
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 189,
    fill: "#ea4335",
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fbbc04"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 64,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 114,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 164,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 215,
    r: 14
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 39.5,
    fill: "#34a853",
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 89.5,
    fill: "#34a853",
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 139.5,
    fill: "#34a853",
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.5,
    cy: 189.5,
    fill: "#34a853",
    r: 16.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4285f4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 64,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 64,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 114,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 164,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 114,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 164,
    r: 19
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAi);
export default __webpack_public_path__ + "static/media/google-ai.69fcecfb22c9635409b86b4c7b541cba.svg";
export { ForwardRef as ReactComponent };